import { Routes, Route } from "react-router-dom";
import { useRef } from "react";

import Navbar from "./Navbar/Navbar";
import offerData from "./OfferSection/offerData.json";
import HeroSection from "./HeroSection/HeroSection";
import EasySection from "./EasySection/EasySection";

// import ReelSection from "./ReelSection/ReelSection";
import VideoSection from "./VideoSection/VideoSection";

import IconsSection from "./IconsSection/IconsSection";
import RocketSection from "./RocketSection/RocketSection";
import TestimonialSection from "./TestimonialSection/TestimonialSection";
import ClientsSection from "./ClientsSection/ClientsSection";
import ContactSection from "./ContactSection/ContactSection";
import ButtomSection from "./ButtomSection/ButtomSection";
import FormPage from "./Forms/FormPage";

import StickyAgent from "./StickyAgent/StickyAgent";


import "./App.css";

function HomePage() {
  const easySectionRef = useRef(null);
  const offerSectionRef = useRef(null);
  const contactSectionRef = useRef(null);

  const scrollToContactSection = () => {
    if (contactSectionRef.current) {
      contactSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToEasySection = () => {
    if (easySectionRef.current) {
      easySectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToOfferSection = () => {
    if (offerSectionRef.current) {
      offerSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <Navbar
        scrollToContactSection={scrollToContactSection}
        scrollToOfferSection={scrollToOfferSection}
      />
      <HeroSection scrollToContactSection={scrollToContactSection} />
      <EasySection ref={easySectionRef} />
     <IconsSection />
      {/* <ReelSection /> */}
      <VideoSection />
 
      <RocketSection />
      <TestimonialSection />
      <ClientsSection />
      {/* <OfferSection offerData={offerData} ref={offerSectionRef}/> */}
      <ContactSection ref={contactSectionRef} offerData={offerData} />
      <ButtomSection />

         <StickyAgent disableWhenInViewRef={contactSectionRef} />

    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/form" element={<FormPage />} />
    </Routes>
  );
}

export default App;
